var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"StandardBorderedButton",class:[
    _vm.color,
    { disabled: _vm.disabled },
    { fluid: _vm.fluid },
    { 'desktop-fluidity': _vm.desktopFluidity },
    {
      forward: _vm.forwardIcon,
      down: _vm.downChevron,
    },
  ],on:{"click":function($event){return _vm.emitClick()}}},[(_vm.locked)?_c('div',{staticClass:"lds-ellipsis"},[_c('div'),_c('div'),_c('div'),_c('div')]):[_c('p',[_vm._v(_vm._s(_vm.title))]),(_vm.forwardIcon)?_c('Arrow'):_vm._e(),(_vm.downChevron)?_c('Chevron2',{attrs:{"color":"white"}}):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }